import { Theme } from '@ltvco/refresh-lib/theme';

export const getModalStyles = (isMobile?: boolean) => {
  if (isMobile) {
    return {
      zIndex: 1300,
      '& .MuiDialogContent-root': {
        padding: '0',
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1300,
      },
      '& .MuiDialog-paper': {
        borderRadius: '12px',
        margin: '16px',
        padding: '0',
        width: 'calc(100% - 32px)',
        maxWidth: '400px',
        position: 'fixed',
        left: '45%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 1301,
        maxHeight: 'calc(100vh - 32px)',
        overflowY: 'auto',
      },
    };
  }

  return {
    '& .MuiDialogContent-root': {
      padding: '0',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiDialog-paper': {
      borderRadius: '4px',
      margin: '208px',
      padding: '16px',
      gap: '8px',
      width: '250px',
      position: 'fixed',
      left: `-200px`,
      right: 'auto',
      bottom: '-100px',
      top: 'auto',
      transform: 'none',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    },
  };
};

export const getContainerBoxStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
});
